@if (filteredItemsList) {
<button
  aria-label="App menu"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="selectImports"
  tabindex="0"
  class="trigger-button"
>
  <mds-menu-nav-block [menu]="activeApp" [isDropdown]="true"></mds-menu-nav-block>
</button>
}

<mat-menu #selectImports="matMenu" (closed)="onMenuClosed()" class="imports-menu-content">
  <ng-template matMenuContent>
    <div class="app-dialog-container">
      <section aria-label="App Section" class="app-section" (click)="$event.stopPropagation()">
        <section class="app-select-section">
          <div class="search-white-background">
            <div class="search-bar-container">
              <mds-icon
                [key]="mdsIcon.SEARCH_DARK"
                [width]="24"
                [height]="24"
                class="right-icon-margin search-icon"
                [pathColors]="[colorAliases.ON_TERTIARY]"
              ></mds-icon>
              <input
                mat-menu-item
                class="light-theme"
                #searchInput
                name="search"
                aria-label="searchbox"
                role="searchbox"
                autocomplete="off"
                [placeholder]="searchPlaceholder"
                [value]="searchText"
                (input)="onSearch($event.target.value)"
              />
              @if (!searchText.length) {
              <mds-icon
                tabindex="0"
                [key]="mdsIcon.ARROW_FORWARD_LIGHT"
                [width]="20"
                [height]="20"
                [inline]="true"
                class="button-icon"
                [pathColors]="[colorAliases.PRIMARY_CONTAINER_HOVER]"
              ></mds-icon>
              } @if (searchText.length) {
              <button class="clear-button-container" (click)="onSearch('')">
                <mds-icon
                  tabindex="0"
                  aria-label="Clear"
                  [key]="mdsIcon.CLOSE"
                  [width]="20"
                  [height]="20"
                  [inline]="true"
                  class="button-icon clear-button"
                  [pathColors]="[colorAliases.PRIMARY]"
                ></mds-icon>
              </button>
              }
            </div>
          </div>
          @if(subGroupToggleMenu.length){
          <mat-button-toggle-group
            [multiple]="false"
            [name]="'App Data'"
            [value]="selectedSubGroup"
            [hideSingleSelectionIndicator]="true"
            class="apps-menu-button-toggle-group"
          >
            @for (switch of subGroupToggleMenu;let i = $index; track i){
            <button
              mat-menu-item
              (click)="onSubGroupChange(switch.value)"
              [attr.data-testid]="'category-' + switch.value"
              class="apps-menu-button-parent"
              [ngClass]="{
                'apps-menu-button-parent--active': selectedSubGroup === switch.value
              }"
            >
              <mat-button-toggle
                class="apps-menu-button-toggle"
                #switchToggle="matButtonToggle"
                [value]="switch.value"
                [checked]="selectedSubGroup === switch.value"
                [disabled]="switch.disabled"
                [attr.aria-label]="switch.ariaLabel"
              >
                @if (switch.icon) {
                <mds-icon
                  [key]="switch.icon"
                  [width]="20"
                  [height]="20"
                  [inline]="true"
                  class="left-icon-margin"
                ></mds-icon>
                }
                <span class="button-label">{{ switch.label || switch.name || switch.value }}</span>
              </mat-button-toggle>
            </button>
            }
          </mat-button-toggle-group>
          }
        </section>

        <section class="apps-section">
          @for (group of filteredItemsList; track group) {
          <article>
            @if (group.items.length) {
            <mds-app-header [header]="group.title" [showCloseButton]="false"></mds-app-header>
            @for (subGroup of group.items; track subGroup) { @if (!!group.showSubGroupTitles) {
            <div class="sub-category">{{ subGroup.title }}</div>
            } @for (item of subGroup.items; track item; let i = $index) { @if (!group.limit || group.isExpanded || i <
            group.limit) {
            <div class="app-content">
              @if (isItemLoading(item.rid)) {
              <ng-container [ngTemplateOutlet]="showLoader"></ng-container>
              }
              <button
                mat-menu-item
                class="app-item-button"
                [ngClass]="{
                        'app-item-button--loading': isItemLoading(item.rid)
                      }"
                (click)="onItemClick(item)"
              >
            <mds-apps
                  [attr.data-testid]="item.app_name"
                  [disableFavorite]="isItemLoading(item.rid)"
                  [subTitle]="item.description_short"
                  [rightText]="item.category"
                  [showFavoriteButton]="!!group.enableFavouriteButton"
                  [title]="item.app_name"
                  [iconColor]="null"
                  [icon]="getAppIcon(item)"
                  [favorite]="!!group.isFavorite"
                  [isOddSection]="false"
                  [isActive]="activeApp.name.toLowerCase() === item.app_name.toLowerCase() || activeApp.name.toLowerCase() === 'importing: ' + item.app_name.toLowerCase()"
                  [favoriteAriaLabel]="item.description_solution"
                  (onFavoriteChange)="onFavoriteValueChange($event, item.rid)"
                ></mds-apps>
              </button>
            </div>
            } } @if (group.limit && subGroup.items.length > group.limit) {
            <button mat-menu-item class="show-more" (click)="group.isExpanded = !group.isExpanded">
              <mds-button
                [aria-label]="'show more'"
                [disabled]="false"
                [icon]="group.isExpanded ? mdsIcon.KEYBOARD_ARROW_UP : mdsIcon.KEYBOARD_ARROW_DOWN"
                [isIconLeft]="true"
                [isIconRight]="true"
                [isLeftRightIconSame]="true"
                [size]="'small'"
                [type]="'tertiary'"
              >
                {{ group.isExpanded ? 'Show less' : 'Show more (' + (subGroup.items.length - group.limit) + ')' }}
              </mds-button>
            </button>
            } } }
          </article>
          } @if (!filteredItemsList.length) {
          <div class="sub-category">{{ noResultsText }}</div>
          }
        </section>
      </section>
    </div>
  </ng-template>

  <ng-template #showLoader>
    <div class="app-loader">
      <mds-loader></mds-loader>
    </div>
  </ng-template>
</mat-menu>
